"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeCalendar = exports.MultipleCalendar = exports.Calendar = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@bem-react/core");
var _1 = require(".");
tslib_1.__exportStar(require("."), exports);
var enhancer = core_1.compose(core_1.composeU(_1.withViewBrand, _1.withViewDefault), core_1.composeU(_1.withSizeS, _1.withSizeM, _1.withSizeL));
exports.Calendar = enhancer(_1.Calendar);
exports.MultipleCalendar = enhancer(_1.MultipleCalendar);
exports.RangeCalendar = enhancer(_1.RangeCalendar);
if (process.env.NODE_ENV !== 'production') {
    exports.Calendar.displayName = 'Bundle(CalendarDesktop)';
    exports.MultipleCalendar.displayName = 'Bundle(MultipleCalendarDesktop)';
    exports.RangeCalendar.displayName = 'Bundle(RangeCalendarDesktop)';
}
